import { useQuery } from '@tanstack/react-query';
import { fetchExamsByMasterExam } from '../services/examCategoryService';

export function useExamsByMasterExam(masterExamId) {
  return useQuery({
    queryKey: ['examsByMasterExam', Number(masterExamId)],
    queryFn: () => fetchExamsByMasterExam(Number(masterExamId)),
    enabled: Number(masterExamId) > 0,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
